import React, { useEffect, useState, useRef, memo, useCallback } from "react";
import Konva from 'konva';
import { Stage, Layer, Line, Arrow, Ellipse, Rect, Transformer } from "react-konva";
import { screenState } from "../../store/screen/slice";
import { useAppSelector } from "../../store/hooks";

import { Portal } from "../../utils/components";

const DrawingTool = (props: any) => {
  const { stepState, canvasClear, addDraw, drawData, setDraw, toolSwitch, jobType, drawSetting, scale, hideDraw, selectionBoxRef, setSelectionBox, setGroupSelect, setAllIsOnLock, setContainerPosition, nowPage } = props;
  const { username, boardInfo, pageInfo } = useAppSelector(state => screenState(state));
  const componentStageRef = useRef<Konva.Stage>(null);
  const [drawComponent, setDrawComponent] = useState<any>(null);
  // const stageRef = useRef<Konva.Stage>(null);
  const [shapes, setShapes] = useState<any>([]);
  const ellipseRef = useRef<any>(null);
  const rectRef = useRef<any>(null);
  const isDrawing = useRef<any>(false);
  const transformerRef = useRef<any>(null);
  const [eraser, setEraser] = useState<any>(false);
  const [selectedShapeId, setSelectedShapeId] = useState<string | null>(null);
  const [stageSize, setStageSize] = useState({
    width: 1920,
    height: 1080
  });
  const [teacherScreen, setTeacherScreen] = useState<number>(0);
  const [studentScreen, setStudentScreen] = useState<number>(0);

  



  const isMoving = useRef<any>(false);
  const konvaRef = useRef<any>(null);
  const stageRef = useRef<any>(null);
  const layerRef = useRef<any>(null);
  const shapeRef = useRef<any>(null);


  useEffect(() => {    
    const handleResize = () => {
      setStudentScreen(1920);
      setStageSize({
        width: 1920,
        height: 1080
      });
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [teacherScreen, studentScreen]);

  // const handleMouseDown = (e: any) => {
  //   if (e.target === e.target.getStage()) {
  //     setSelectedShapeId(null);
  //   }
  //   // 
  //   if (drawSetting.mode === "eraser") {
  //     setEraser(true);
  //   } else {
  //     isDrawing.current = true;
  //     const pos = e.target.getStage().getPointerPosition();
  //     const transformedPos = {
  //       x: pos.x / scale,
  //       y: pos.y / scale,
  //     };
  //     if (drawSetting.mode === "pencil") {
  //       setShapes([
  //         ...shapes,
  //         {
  //           id: Math.random().toString(),
  //           type: drawSetting.mode,
  //           points: [transformedPos.x, transformedPos.y],
  //           strokeWidth: drawSetting.size,
  //           stroke: drawSetting.color,
  //           originalX: transformedPos.x,
  //           originalY: transformedPos.y,
  //         },
  //       ]);
  //     } else if (drawSetting.mode === "highlighter") {
  //       setShapes([
  //         ...shapes,
  //         {
  //           id: Math.random().toString(),
  //           type: drawSetting.mode,
  //           points: [transformedPos.x, transformedPos.y],
  //           strokeWidth: drawSetting.size,
  //           stroke: drawSetting.color,
  //           originalX: transformedPos.x,
  //           originalY: transformedPos.y,
  //         },
  //       ]);
  //     } else if (drawSetting.mode === "pattern" && drawSetting.type === "line") {
  //       setShapes([
  //         ...shapes,
  //         {
  //           id: Math.random().toString(),
  //           type: drawSetting.type,
  //           points: [transformedPos.x, transformedPos.y, transformedPos.x, transformedPos.y],
  //           strokeWidth: drawSetting.size,
  //           stroke: drawSetting.color,
  //           originalX: transformedPos.x,
  //           originalY: transformedPos.y,
  //         },
  //       ]);
  //     } else if (drawSetting.mode === "pattern" && drawSetting.type === "arrow") {
  //       setShapes([
  //         ...shapes,
  //         {
  //           id: Math.random().toString(),
  //           type: drawSetting.type,
  //           points: [transformedPos.x, transformedPos.y, transformedPos.x, transformedPos.y],
  //           strokeWidth: drawSetting.size,
  //           stroke: drawSetting.color,
  //           fill: drawSetting.color,
  //           originalX: transformedPos.x,
  //           originalY: transformedPos.y,
  //         },
  //       ]);
  //     } else if (drawSetting.mode === "pattern" && drawSetting.type === "ellipse") {
  //       ellipseRef.current = {
  //         id: Math.random().toString(),
  //         type: drawSetting.type,
  //         startX: transformedPos.x,
  //         startY: transformedPos.y,
  //         x: transformedPos.x,
  //         y: transformedPos.y,
  //         radiusX: 0,
  //         radiusY: 0,
  //         strokeWidth: drawSetting.size,
  //         stroke: drawSetting.color,
  //         fill: "transparent",
  //         originalX: transformedPos.x,
  //         originalY: transformedPos.y,
  //       };
  //       setShapes([...shapes, ellipseRef.current]);
  //     } else if (drawSetting.mode === "pattern" && drawSetting.type === "rect") {
  //       rectRef.current = {
  //         id: Math.random().toString(),
  //         type: drawSetting.type,
  //         x: transformedPos.x,
  //         y: transformedPos.y,
  //         width: 0,
  //         height: 0,
  //         strokeWidth: drawSetting.size,
  //         stroke: drawSetting.color,
  //         fill: "transparent",
  //         originalX: transformedPos.x,
  //         originalY: transformedPos.y,
  //       };
  //       setShapes([...shapes, rectRef.current]);
  //     } else if (drawSetting.mode === "pattern" && drawSetting.type === "ellipseFill") {
  //       ellipseRef.current = {
  //         id: Math.random().toString(),
  //         type: drawSetting.type,
  //         startX: transformedPos.x,
  //         startY: transformedPos.y,
  //         x: transformedPos.x,
  //         y: transformedPos.y,
  //         radiusX: 0,
  //         radiusY: 0,
  //         strokeWidth: drawSetting.size,
  //         stroke: drawSetting.color,
  //         fill: drawSetting.color,
  //         originalX: transformedPos.x,
  //         originalY: transformedPos.y,
  //       };
  //       setShapes([...shapes, ellipseRef.current]);
  //     } else if (drawSetting.mode === "pattern" && drawSetting.type === "rectFill") {
  //       rectRef.current = {
  //         id: Math.random().toString(),
  //         type: drawSetting.type,
  //         x: transformedPos.x,
  //         y: transformedPos.y,
  //         width: 0,
  //         height: 0,
  //         strokeWidth: drawSetting.size,
  //         stroke: drawSetting.color,
  //         fill: drawSetting.color,
  //         originalX: transformedPos.x,
  //         originalY: transformedPos.y,
  //       };
  //       setShapes([...shapes, rectRef.current]);
  //     }
  //   }
  // };

  // const handleMouseMove = (e: any) => {
  //   if (drawSetting.mode === "eraser") {
  //     if (eraser) {
  //       const stage = stageRef.current;
  //       if (stage) {
  //         const pos = stage.getPointerPosition();
  //         if (pos) {
            
  //           const scaledPos = {
  //             x: pos.x,
  //             y: pos.y,
  //           };

  //           const target = stage.getIntersection(scaledPos);
  //           if (target && target.attrs.customId) {
  //             const newShapes = shapes.filter((shape: any) => shape.id !== target.attrs.customId);
  //             setShapes(newShapes);
  //           }
  //         }
  //       }
  //     }
  //   } else {
  //     if (!isDrawing.current || drawSetting.mode === "eraser") {
  //       return;
  //     }

  //     const pos = e.target.getStage().getPointerPosition();
  //     const transformedPos = {
  //       x: pos.x / scale,
  //       y: pos.y / scale,
  //     };

  //     if (drawSetting.mode === "pencil") {
  //       const lastLine = shapes[shapes.length - 1];
  //       lastLine.points = lastLine.points.concat([transformedPos.x, transformedPos.y]);
  //       lastLine.originalX = Math.min(lastLine.originalX, transformedPos.x);
  //       lastLine.originalY = Math.min(lastLine.originalY, transformedPos.y);
  //       setShapes([...shapes.slice(0, shapes.length - 1), lastLine]);
  //     } else if (drawSetting.mode === "highlighter") {
  //       const lastLine = shapes[shapes.length - 1];
  //       lastLine.points = lastLine.points.concat([transformedPos.x, transformedPos.y]);
  //       lastLine.originalX = Math.min(lastLine.originalX, transformedPos.x);
  //       lastLine.originalY = Math.min(lastLine.originalY, transformedPos.y);
  //       setShapes([...shapes.slice(0, shapes.length - 1), lastLine]);
  //     } else if (drawSetting.mode === "pattern" && drawSetting.type === "line") {
  //       const lastLine = shapes[shapes.length - 1];
  //       setShapes([
  //         ...shapes.slice(0, shapes.length - 1),
  //         {
  //           id: Math.random().toString(),
  //           type: drawSetting.type,
  //           stroke: drawSetting.color,
  //           points: [...lastLine.points.slice(0, 2), transformedPos.x, transformedPos.y],
  //           strokeWidth: drawSetting.size,
  //         },
  //       ]);
  //     } else if (drawSetting.mode === "pattern" && drawSetting.type === "arrow") {
  //       const lastLine = shapes[shapes.length - 1];
  //       setShapes([
  //         ...shapes.slice(0, shapes.length - 1),
  //         {
  //           id: Math.random().toString(),
  //           type: drawSetting.type,
  //           stroke: drawSetting.color,
  //           fill: drawSetting.color,
  //           points: [...lastLine.points.slice(0, 2), transformedPos.x, transformedPos.y],
  //           strokeWidth: drawSetting.size,
  //         },
  //       ]);
  //     } else if (drawSetting.mode === "pattern" && drawSetting.type === "ellipse" || drawSetting.mode === "pattern" && drawSetting.type === "ellipseFill") {
  //       const updatedShapes = shapes.slice(0, shapes.length - 1);
  //       const { startX, startY } = ellipseRef.current;
  //       const radiusX = Math.abs(transformedPos.x - startX) / 2;
  //       const radiusY = Math.abs(transformedPos.y - startY) / 2;
  //       const x = startX + (transformedPos.x - startX) / 2;
  //       const y = startY + (transformedPos.y - startY) / 2;
  //       const width = transformedPos.x - startX;
  //       const height = transformedPos.y - startY;

  //       ellipseRef.current = {
  //         width: width,
  //         height: height,
  //         type: ellipseRef.current.type,
  //         startX, startY,
  //         x,
  //         y,
  //         radiusX,
  //         radiusY,
  //         id: ellipseRef.current.id,
  //         strokeWidth: ellipseRef.current.strokeWidth,
  //         stroke: ellipseRef.current.stroke,
  //         fill: ellipseRef.current.fill
  //       };

  //       setShapes([...updatedShapes, { ...ellipseRef.current }]);

  //     } else if (drawSetting.mode === "pattern" && drawSetting.type === "rect" || drawSetting.mode === "pattern" && drawSetting.type === "rectFill") {
  //       const updatedShapes = shapes.slice(0, shapes.length - 1);
  //       const { x, y } = rectRef.current;
  //       const width = transformedPos.x - x;
  //       const height = transformedPos.y - y;

  //       rectRef.current.width = width;
  //       rectRef.current.height = height;
  //       setShapes([...updatedShapes, { ...rectRef.current }]);
  //     }
  //   }
  // };

  // const handleMouseUp = (e: any) => {
  //   isDrawing.current = false;
  //   setEraser(false);

  //   if (drawSetting.mode !== "eraser") {
  //     const pos = e.target.getStage().getPointerPosition();
  //     const transformedPos = {
  //       x: pos.x / scale,
  //       y: pos.y / scale,
  //     };
  //     if (drawSetting.mode === "pencil" || drawSetting.mode === "highlighter" || drawSetting.mode === "pattern" && (drawSetting.type === "line" || drawSetting.type === "arrow")) {
  //       const lastLine = shapes[shapes.length - 1];
  //       if (lastLine) {
  //         if (drawSetting.mode === "pencil") {
  //           lastLine.points = lastLine.points.concat([transformedPos.x, transformedPos.y]);
  //           setShapes([...shapes.slice(0, shapes.length - 1), lastLine]);

  //           const minX = Math.min(...lastLine.points.filter((_: any, index: any) => index % 2 === 0));
  //           const maxX = Math.max(...lastLine.points.filter((_: any, index: any) => index % 2 === 0));
  //           const minY = Math.min(...lastLine.points.filter((_: any, index: any) => index % 2 !== 0));
  //           const maxY = Math.max(...lastLine.points.filter((_: any, index: any) => index % 2 !== 0));
  //           const width = maxX - minX;
  //           const height = maxY - minY;
  //           setDrawComponent({
  //             ...lastLine,
  //             width: width,
  //             height: height,
  //           });
  //         } else if (drawSetting.mode === "highlighter") {
  //           lastLine.points = lastLine.points.concat([transformedPos.x, transformedPos.y]);
  //           setShapes([...shapes.slice(0, shapes.length - 1), lastLine]);

  //           const minX = Math.min(...lastLine.points.filter((_: any, index: any) => index % 2 === 0));
  //           const maxX = Math.max(...lastLine.points.filter((_: any, index: any) => index % 2 === 0));
  //           const minY = Math.min(...lastLine.points.filter((_: any, index: any) => index % 2 !== 0));
  //           const maxY = Math.max(...lastLine.points.filter((_: any, index: any) => index % 2 !== 0));
  //           const width = maxX - minX;
  //           const height = maxY - minY;
  //           setDrawComponent({
  //             ...lastLine,
  //             width: width,
  //             height: height,
  //           });
  //         } else if (drawSetting.mode === "pattern" && drawSetting.type === "line") {
  //           setShapes([
  //             ...shapes.slice(0, shapes.length - 1),
  //             {
  //               id: Math.random().toString(),
  //               type: drawSetting.type,
  //               stroke: drawSetting.color,
  //               points: [...lastLine.points.slice(0, 2), transformedPos.x, transformedPos.y],
  //               strokeWidth: drawSetting.size,
  //             },
  //           ]);

  //           const minX = Math.min(...lastLine.points.filter((_: any, index: any) => index % 2 === 0));
  //           const maxX = Math.max(...lastLine.points.filter((_: any, index: any) => index % 2 === 0));
  //           const minY = Math.min(...lastLine.points.filter((_: any, index: any) => index % 2 !== 0));
  //           const maxY = Math.max(...lastLine.points.filter((_: any, index: any) => index % 2 !== 0));
  //           const width = maxX - minX;
  //           const height = maxY - minY;
  //           setDrawComponent({
  //             ...lastLine,
  //             width: width,
  //             height: height,
  //             originalX: Math.abs(minX),
  //             originalY: Math.abs(minY)
  //           });
  //         } else if (drawSetting.mode === "pattern" && drawSetting.type === "arrow") {
  //           setShapes([
  //             ...shapes.slice(0, shapes.length - 1),
  //             {
  //               id: Math.random().toString(),
  //               type: drawSetting.type,
  //               stroke: drawSetting.color,
  //               fill: drawSetting.color,
  //               points: [...lastLine.points.slice(0, 2), transformedPos.x, transformedPos.y],
  //               strokeWidth: drawSetting.size,
  //             },
  //           ]);

  //           const minX = Math.min(...lastLine.points.filter((_: any, index: any) => index % 2 === 0));
  //           const maxX = Math.max(...lastLine.points.filter((_: any, index: any) => index % 2 === 0));
  //           const minY = Math.min(...lastLine.points.filter((_: any, index: any) => index % 2 !== 0));
  //           const maxY = Math.max(...lastLine.points.filter((_: any, index: any) => index % 2 !== 0));
  //           const width = maxX - minX;
  //           const height = maxY - minY;
  //           setDrawComponent({
  //             ...lastLine,
  //             width: width,
  //             height: height,
  //             originalX: Math.abs(minX),
  //             originalY: Math.abs(minY)
  //           });
  //         }
  //       }
  //     } else if (drawSetting.mode === "pattern" && drawSetting.type !== "line") {
  //       const lastLine = shapes[shapes.length - 1];
  //       if (lastLine) {
  //         if (drawSetting.mode === "pattern" && drawSetting.type === "ellipse" || drawSetting.mode === "pattern" && drawSetting.type === "ellipseFill") {
  //           const { startX, startY } = ellipseRef.current;
  //           const radiusX = Math.abs(transformedPos.x - startX) / 2;
  //           const radiusY = Math.abs(transformedPos.y - startY) / 2;
  //           const x = startX + (transformedPos.x - startX) / 2;
  //           const y = startY + (transformedPos.y - startY) / 2;
  //           const width = transformedPos.x - startX;
  //           const height = transformedPos.y - startY;
    
  //           ellipseRef.current = {
  //             width: Math.abs(width),
  //             height: Math.abs(height),
  //             originalX: Math.abs(Math.min(startX, transformedPos.x)),
  //             originalY: Math.abs(Math.min(startY, transformedPos.y)),
    
  //             type: ellipseRef.current.type,
  //             startX, startY,
  //             x,
  //             y,
  //             radiusX,
  //             radiusY,
  //             id: ellipseRef.current.id,
  //             strokeWidth: ellipseRef.current.strokeWidth,
  //             stroke: ellipseRef.current.stroke,
  //             fill: ellipseRef.current.fill
  //           };
  //           setDrawComponent(ellipseRef.current);
    
  //         } else if (drawSetting.mode === "pattern" && drawSetting.type === "rect" || drawSetting.mode === "pattern" && drawSetting.type === "rectFill") {
  //           const { x, y } = rectRef.current;
  //           const width = transformedPos.x - x;
  //           const height = transformedPos.y - y;
    
  //           rectRef.current.width = Math.abs(width);
  //           rectRef.current.height = Math.abs(height);
  //           rectRef.current.originalX = Math.abs(Math.min(x, transformedPos.x));
  //           rectRef.current.originalY = Math.abs(Math.min(y, transformedPos.y));
  //           setDrawComponent(rectRef.current);
  //         }
  //       }
  //     }
  //   }
  // };

  const handleSelect = (shape: any) => {
    setSelectedShapeId(shape.id);
    if (
      shape instanceof Konva.Line ||
      shape instanceof Konva.Ellipse ||
      shape instanceof Konva.Rect ||
      shape instanceof Konva.Arrow
    ) {
      transformerRef.current.attachTo(shape);
    }
  };

  useEffect(() => {
    if (componentStageRef.current && drawComponent) {
      // const stage = stageRef.current;
      const stage = konvaRef.current;
      if (stage) {
        const stageWidth = stage.width();
        const stageHeight = stage.height();
        if (stageWidth > 0 && stageHeight > 0) {
          const base64 = componentStageRef.current.toDataURL({ pixelRatio: 4 });
          if (base64) {
            addDraw(drawComponent, base64, () => {
              // setShapes([]);
            });
          }
        }
      }
    }
  }, [componentStageRef, drawComponent]);

  useEffect(() => {
    if (!konvaRef.current) {
      const stage = new Konva.Stage({
        container: stageRef.current,
        width: stageSize.width * scale,
        height: stageSize.height * scale,
        scaleX: scale,
        scaleY: scale
      });
      konvaRef.current = stage;
      const layer = new Konva.Layer();
      stage.add(layer);
      layerRef.current = layer;

      setTimeout(() => {
        stage.on('mousedown touchstart', handleMouseDown);
        stage.on('mousemove touchmove', handleMouseMove);
        stage.on('mouseup touchend', handleMouseUp);
      }, 100);

      return () => {
        stage.off('mousedown touchstart');
        stage.off('mousemove touchmove');
        stage.off('mouseup touchend');
      };
    }
  }, []);

  const handleMouseDown = useCallback((e: any) => {
    isDrawing.current = true;
    
    if (selectionBoxRef.current) {
      selectionBoxRef.current = null;
    }
    setSelectionBox(null);
    setGroupSelect(false);
    setAllIsOnLock(false);
    setContainerPosition(null);

    const pos = e.target.getStage().getPointerPosition();
    const transformedPos = {
      x: pos.x / scale,
      y: pos.y / scale,
    };
    if (drawSetting.mode === "pencil") {
      const newLine = new Konva.Line({
        id: Math.random().toString(),
        type: drawSetting.mode,
        points: [transformedPos.x, transformedPos.y],
        strokeWidth: drawSetting.size,
        stroke: drawSetting.color,
        originalX: transformedPos.x,
        originalY: transformedPos.y,
        lineCap: 'round',
        lineJoin: 'round',
        tension: 0,
      });
      layerRef.current.add(newLine);
      shapeRef.current = newLine;
    } else if (drawSetting.mode === "highlighter") {
      const newLine = new Konva.Line({
        id: Math.random().toString(),
        type: drawSetting.mode,
        points: [transformedPos.x, transformedPos.y],
        strokeWidth: drawSetting.size,
        stroke: drawSetting.color,
        originalX: transformedPos.x,
        originalY: transformedPos.y,
        lineCap: 'round',
        lineJoin: 'round',
        tension: 0,
        opacity: 0.5
      });
      layerRef.current.add(newLine);
      shapeRef.current = newLine;
    } else if (drawSetting.mode === "pattern" && drawSetting.type === "line") {
      const newLine = new Konva.Line({
        id: Math.random().toString(),
        type: drawSetting.type,
        points: [transformedPos.x, transformedPos.y, transformedPos.x, transformedPos.y],
        strokeWidth: drawSetting.size,
        stroke: drawSetting.color,
        originalX: transformedPos.x,
        originalY: transformedPos.y,
        lineCap: 'round',
        lineJoin: 'round',
        tension: 0.5
      });
      layerRef.current.add(newLine);
      shapeRef.current = newLine;
    } else if (drawSetting.mode === "pattern" && drawSetting.type === "arrow") {
      const newLine = new Konva.Arrow({
        id: Math.random().toString(),
        type: drawSetting.type,
        points: [transformedPos.x, transformedPos.y, transformedPos.x, transformedPos.y],
        strokeWidth: drawSetting.size,
        stroke: drawSetting.color,
        originalX: transformedPos.x,
        originalY: transformedPos.y,
        lineCap: 'round',
        lineJoin: 'miter',
        tension: 0.5
      });
      layerRef.current.add(newLine);
      shapeRef.current = newLine;
    } else if (drawSetting.mode === "pattern" && drawSetting.type === "ellipse") {
      const newLine = new Konva.Ellipse({
        id: Math.random().toString(),
        type: drawSetting.type,
        startX: transformedPos.x,
        startY: transformedPos.y,
        x: transformedPos.x,
        y: transformedPos.y,
        radiusX: 0,
        radiusY: 0,
        strokeWidth: drawSetting.size,
        stroke: drawSetting.color,
        fill: "transparent",
        originalX: transformedPos.x,
        originalY: transformedPos.y,
      });
      layerRef.current.add(newLine);
      shapeRef.current = newLine;
    } else if (drawSetting.mode === "pattern" && drawSetting.type === "rect") {
      const newLine = new Konva.Rect({
        id: Math.random().toString(),
        type: drawSetting.type,
        x: transformedPos.x,
        y: transformedPos.y,
        width: 0,
        height: 0,
        strokeWidth: drawSetting.size,
        stroke: drawSetting.color,
        fill: "transparent",
        originalX: transformedPos.x,
        originalY: transformedPos.y,
      });
      layerRef.current.add(newLine);
      shapeRef.current = newLine;
    } else if (drawSetting.mode === "pattern" && drawSetting.type === "ellipseFill") {
      const newLine = new Konva.Ellipse({
        id: Math.random().toString(),
        type: drawSetting.type,
        startX: transformedPos.x,
        startY: transformedPos.y,
        x: transformedPos.x,
        y: transformedPos.y,
        radiusX: 0,
        radiusY: 0,
        strokeWidth: drawSetting.size,
        stroke: drawSetting.color,
        fill: drawSetting.color,
        originalX: transformedPos.x,
        originalY: transformedPos.y,
      });
      layerRef.current.add(newLine);
      shapeRef.current = newLine;
    } else if (drawSetting.mode === "pattern" && drawSetting.type === "rectFill") {
      const newLine = new Konva.Rect({
        id: Math.random().toString(),
        type: drawSetting.type,
        x: transformedPos.x,
        y: transformedPos.y,
        width: 0,
        height: 0,
        strokeWidth: drawSetting.size,
        stroke: drawSetting.color,
        fill: drawSetting.color,
        originalX: transformedPos.x,
        originalY: transformedPos.y,
      });
      layerRef.current.add(newLine);
      shapeRef.current = newLine;
    }
  }, [scale, drawSetting, selectionBoxRef.current]);

  const handleMouseMove = useCallback((e: any) => {
    if (!isDrawing.current || !shapeRef.current) return;
    if (isMoving.current) return;
    e.evt.preventDefault();
    isMoving.current = true;
    setTimeout(() => {
      isMoving.current = false;
    }, 10);
    const pos = e.target.getStage().getPointerPosition();
    const transformedPos = {
      x: pos.x / scale,
      y: pos.y / scale,
    };
    if (drawSetting.mode === "pencil") {
      const newPoints = shapeRef.current.points().concat([transformedPos.x, transformedPos.y]);
      shapeRef.current.setAttrs({
        originalX: Math.min(shapeRef.current.attrs.originalX, transformedPos.x),
        originalY: Math.min(shapeRef.current.attrs.originalY, transformedPos.y)
      });
      shapeRef.current.points(newPoints);
      shapeRef.current.getLayer().batchDraw();
    } else if (drawSetting.mode === "highlighter") {
      const newPoints = shapeRef.current.points().concat([transformedPos.x, transformedPos.y]);
      shapeRef.current.setAttrs({
        originalX: Math.min(shapeRef.current.attrs.originalX, transformedPos.x),
        originalY: Math.min(shapeRef.current.attrs.originalY, transformedPos.y)
      });
      shapeRef.current.points(newPoints);
      shapeRef.current.getLayer().batchDraw();
    } else if (drawSetting.mode === "pattern" && drawSetting.type === "line") {
      const newPoints = [...shapeRef.current.points().slice(0, 2), transformedPos.x, transformedPos.y];
      shapeRef.current.setAttrs({
        originalX: Math.min(shapeRef.current.attrs.originalX, transformedPos.x),
        originalY: Math.min(shapeRef.current.attrs.originalY, transformedPos.y)
      });
      shapeRef.current.points(newPoints);
      shapeRef.current.getLayer().batchDraw();
    } else if (drawSetting.mode === "pattern" && drawSetting.type === "arrow") {
      const newPoints = [...shapeRef.current.points().slice(0, 2), transformedPos.x, transformedPos.y];
      shapeRef.current.setAttrs({
        originalX: Math.min(shapeRef.current.attrs.originalX, transformedPos.x),
        originalY: Math.min(shapeRef.current.attrs.originalY, transformedPos.y)
      });
      shapeRef.current.points(newPoints);
      shapeRef.current.getLayer().batchDraw();
    } else if (drawSetting.mode === "pattern" && drawSetting.type === "ellipse" || drawSetting.mode === "pattern" && drawSetting.type === "ellipseFill") {
      const { startX, startY } = shapeRef.current.attrs;
      const radiusX = Math.abs(transformedPos.x - startX) / 2;
      const radiusY = Math.abs(transformedPos.y - startY) / 2;
      const x = startX + (transformedPos.x - startX) / 2;
      const y = startY + (transformedPos.y - startY) / 2;
      const width = transformedPos.x - startX;
      const height = transformedPos.y - startY;
      shapeRef.current.setAttrs({
        width: width,
        height: height,
        radiusX: radiusX,
        radiusY: radiusY,
        x: x,
        y: y
      });
      shapeRef.current.getLayer().batchDraw();
    } else if (drawSetting.mode === "pattern" && drawSetting.type === "rect" || drawSetting.mode === "pattern" && drawSetting.type === "rectFill") {
      const { x, y } = shapeRef.current.attrs;
      const width = transformedPos.x - x;
      const height = transformedPos.y - y;
      shapeRef.current.setAttrs({
        width: width,
        height: height
      });
      shapeRef.current.getLayer().batchDraw();
    }
  }, [scale, drawSetting]);

  const handleMouseUp = (e: any) => {
    isDrawing.current = false;

    const pos = e.target.getStage().getPointerPosition();
    const transformedPos = {
      x: pos.x / scale,
      y: pos.y / scale,
    };
    if (drawSetting.mode === "pencil" || drawSetting.mode === "highlighter" || drawSetting.mode === "pattern" && (drawSetting.type === "line" || drawSetting.type === "arrow")) {
      if (shapeRef.current) {
        if (drawSetting.mode === "pencil") {
          const newPoints = shapeRef.current.points().concat([transformedPos.x, transformedPos.y]);
          shapeRef.current.points(newPoints);
          shapeRef.current.getLayer().batchDraw();
          const minX = Math.min(...shapeRef.current.points().filter((_: any, index: any) => index % 2 === 0));
          const maxX = Math.max(...shapeRef.current.points().filter((_: any, index: any) => index % 2 === 0));
          const minY = Math.min(...shapeRef.current.points().filter((_: any, index: any) => index % 2 !== 0));
          const maxY = Math.max(...shapeRef.current.points().filter((_: any, index: any) => index % 2 !== 0));
          const width = maxX - minX;
          const height = maxY - minY;
          setDrawComponent({
            ...shapeRef.current.attrs,
            width: width,
            height: height,
          });
        } else if (drawSetting.mode === "highlighter") {
          const newPoints = shapeRef.current.points().concat([transformedPos.x, transformedPos.y]);
          shapeRef.current.points(newPoints);
          shapeRef.current.getLayer().batchDraw();
          const minX = Math.min(...shapeRef.current.points().filter((_: any, index: any) => index % 2 === 0));
          const maxX = Math.max(...shapeRef.current.points().filter((_: any, index: any) => index % 2 === 0));
          const minY = Math.min(...shapeRef.current.points().filter((_: any, index: any) => index % 2 !== 0));
          const maxY = Math.max(...shapeRef.current.points().filter((_: any, index: any) => index % 2 !== 0));
          const width = maxX - minX;
          const height = maxY - minY;
          setDrawComponent({
            ...shapeRef.current.attrs,
            width: width,
            height: height,
          });
        } else if (drawSetting.mode === "pattern" && drawSetting.type === "line") {
          const newPoints = [...shapeRef.current.points().slice(0, 2), transformedPos.x, transformedPos.y];
          shapeRef.current.points(newPoints);
          shapeRef.current.getLayer().batchDraw();
          const minX = Math.min(...shapeRef.current.points().filter((_: any, index: any) => index % 2 === 0));
          const maxX = Math.max(...shapeRef.current.points().filter((_: any, index: any) => index % 2 === 0));
          const minY = Math.min(...shapeRef.current.points().filter((_: any, index: any) => index % 2 !== 0));
          const maxY = Math.max(...shapeRef.current.points().filter((_: any, index: any) => index % 2 !== 0));
          const width = maxX - minX;
          const height = maxY - minY;
          setDrawComponent({
            ...shapeRef.current.attrs,
            width: width,
            height: height,
            originalX: Math.abs(minX),
            originalY: Math.abs(minY)
          });
        } else if (drawSetting.mode === "pattern" && drawSetting.type === "arrow") {
          const newPoints = [...shapeRef.current.points().slice(0, 2), transformedPos.x, transformedPos.y];
          shapeRef.current.points(newPoints);
          shapeRef.current.getLayer().batchDraw();
          const minX = Math.min(...shapeRef.current.points().filter((_: any, index: any) => index % 2 === 0));
          const maxX = Math.max(...shapeRef.current.points().filter((_: any, index: any) => index % 2 === 0));
          const minY = Math.min(...shapeRef.current.points().filter((_: any, index: any) => index % 2 !== 0));
          const maxY = Math.max(...shapeRef.current.points().filter((_: any, index: any) => index % 2 !== 0));
          const width = maxX - minX;
          const height = maxY - minY;
          setDrawComponent({
            ...shapeRef.current.attrs,
            width: width,
            height: height,
            originalX: Math.abs(minX),
            originalY: Math.abs(minY)
          });
        }
      }
    } else if (drawSetting.mode === "pattern" && drawSetting.type !== "line") {
      if (shapeRef.current) {
        if (drawSetting.mode === "pattern" && drawSetting.type === "ellipse" || drawSetting.mode === "pattern" && drawSetting.type === "ellipseFill") {
          const { startX, startY } = shapeRef.current.attrs;
          const radiusX = Math.abs(transformedPos.x - startX) / 2;
          const radiusY = Math.abs(transformedPos.y - startY) / 2;
          const x = startX + (transformedPos.x - startX) / 2;
          const y = startY + (transformedPos.y - startY) / 2;
          const width = transformedPos.x - startX;
          const height = transformedPos.y - startY;
          setDrawComponent({
            ...shapeRef.current.attrs,
            width: Math.abs(width),
            height: Math.abs(height),
            originalX: Math.abs(Math.min(startX, transformedPos.x)),
            originalY: Math.abs(Math.min(startY, transformedPos.y)),
          });
        } else if (drawSetting.mode === "pattern" && drawSetting.type === "rect" || drawSetting.mode === "pattern" && drawSetting.type === "rectFill") {
          const { x, y } = shapeRef.current.attrs;
          const width = transformedPos.x - x;
          const height = transformedPos.y - y;
          setDrawComponent({
            ...shapeRef.current.attrs,
            width: Math.abs(width),
            height: Math.abs(height),
            originalX: Math.abs(Math.min(x, transformedPos.x)),
            originalY: Math.abs(Math.min(y, transformedPos.y)),
          });
        }
      }
    }
  };

  useEffect(() => {
    if (!konvaRef.current) return;
    const stage = konvaRef.current.getStage();
    stage.width(stageSize.width * scale);
    stage.height(stageSize.height * scale);
    stage.scale({ x: scale, y: scale });
    stage.batchDraw();

    stage.off('mousedown touchstart');
    stage.off('mousemove touchmove');
    stage.off('mouseup touchend');
    stage.on('mousedown touchstart', handleMouseDown);
    stage.on('mousemove touchmove', handleMouseMove);
    stage.on('mouseup touchend', handleMouseUp);
  }, [konvaRef.current, scale, drawSetting]);

  useEffect(() => {
    if (toolSwitch === "cursor" || (toolSwitch === "draw" && (jobType === "grab" || jobType === "eraser" || jobType === "paint"))) {
      if (layerRef.current) {
        layerRef.current.destroy();
        const layer = new Konva.Layer();
        konvaRef.current.add(layer);
        layerRef.current = layer;
        setDrawComponent(null);
      }
    }
  }, [toolSwitch, jobType, drawSetting, konvaRef.current, layerRef.current, drawComponent]);


  return (
    <React.Fragment>
      {/*  */}
      <Portal visible={nowPage}>
        <div className="draw-component-box">
          <Stage
            ref={componentStageRef}
            width={(drawComponent? drawComponent.width + (drawComponent.strokeWidth === 27? 64 : 32) : 0) * scale}
            height={(drawComponent? drawComponent.height + (drawComponent.strokeWidth === 27? 64 : 32) : 0) * scale}
            scaleX={scale}
            scaleY={scale}
          >
            <Layer>
              {renderDrawComponent(drawComponent, konvaRef)}
            </Layer>
          </Stage>
        </div>
      </Portal>
      {/*  */}
      <div className={`draw-board ${toolSwitch === "draw" && jobType === "draw" ? "show" : ""} ${hideDraw? "hide" : ""}`} style={{ height: 1080 * scale, width: 1920 * scale }}>

        <div id="container" ref={stageRef}></div>


        {/* <Stage
          ref={stageRef}
          width={stageSize.width * scale}
          height={stageSize.height * scale}
          scaleX={scale}
          scaleY={scale}
          onMouseDown={handleMouseDown}
          onMousemove={handleMouseMove}
          onMouseup={handleMouseUp}
          onTouchStart={handleMouseDown}
          onTouchMove={handleMouseMove}
          onTouchEnd={handleMouseUp}
        >
          <Layer>
            {shapes.map((shape: any) => {
              switch (shape.type) {
                case "pencil":
                  return (
                    <Line
                      key={shape.id}
                      id={shape.id}
                      x={shape.x? shape.x : null}
                      y={shape.y? shape.y : null}
                      points={shape.points}
                      stroke={shape.stroke}
                      strokeWidth={shape.strokeWidth}
                      scaleX={shape.scaleX}
                      scaleY={shape.scaleY}
                      tension={0}
                      lineCap="round"
                      lineJoin="round"
                      customId={shape.id}
                      onMouseDown={() => handleSelect(shape)}
                      onTouchStart={() => handleSelect(shape)}
                    />
                  )
                  break;
                case "highlighter":
                  return (
                    <Line
                      key={shape.id}
                      id={shape.id}
                      x={shape.x? shape.x : null}
                      y={shape.y? shape.y : null}
                      points={shape.points}
                      stroke={shape.stroke}
                      opacity={0.5}
                      strokeWidth={shape.strokeWidth}
                      scaleX={shape.scaleX}
                      scaleY={shape.scaleY}
                      tension={0}
                      lineCap="round"
                      lineJoin="round"
                      customId={shape.id}
                      onMouseDown={() => handleSelect(shape)}
                      onTouchStart={() => handleSelect(shape)}
                    />
                  )
                  break;
                case "line":
                  return (
                    <Line
                      key={shape.id}
                      id={shape.id}
                      x={shape.x? shape.x : null}
                      y={shape.y? shape.y : null}
                      points={shape.points}
                      stroke={shape.stroke}
                      strokeWidth={shape.strokeWidth}
                      scaleX={shape.scaleX}
                      scaleY={shape.scaleY}
                      tension={0.5}
                      lineCap="round"
                      lineJoin="round"
                      customId={shape.id}
                      onMouseDown={() => handleSelect(shape)}
                      onTouchStart={() => handleSelect(shape)}
                    />
                  )
                  break;
                case "arrow":
                  return (
                    <Arrow
                      key={shape.id}
                      id={shape.id}
                      x={shape.x? shape.x : null}
                      y={shape.y? shape.y : null}
                      points={shape.points}
                      stroke={shape.stroke}
                      fill={shape.fill}
                      strokeWidth={shape.strokeWidth}
                      scaleX={shape.scaleX}
                      scaleY={shape.scaleY}
                      tension={0.5}
                      lineCap="round"
                      lineJoin="miter"
                      customId={shape.id}
                      onMouseDown={() => handleSelect(shape)}
                      onTouchStart={() => handleSelect(shape)}
                    />
                  )
                  break;
                case "ellipse":
                  return (
                    <Ellipse
                      key={shape.id}
                      id={shape.id}
                      x={shape.x}
                      y={shape.y}
                      stroke={shape.stroke}
                      fill={shape.fill}
                      strokeWidth={shape.strokeWidth}
                      scaleX={shape.scaleX}
                      scaleY={shape.scaleY}
                      radiusX={shape.radiusX}
                      radiusY={shape.radiusY}
                      customId={shape.id}
                      onMouseDown={() => handleSelect(shape)}
                      onTouchStart={() => handleSelect(shape)}
                    />
                  )
                  break;
                case "rect":
                  return (
                    <Rect
                      key={shape.id}
                      id={shape.id}
                      x={shape.x}
                      y={shape.y}
                      stroke={shape.stroke}
                      fill={shape.fill}
                      strokeWidth={shape.strokeWidth}
                      scaleX={shape.scaleX}
                      scaleY={shape.scaleY}
                      width={shape.width}
                      height={shape.height}
                      customId={shape.id}
                      onMouseDown={() => handleSelect(shape)}
                      onTouchStart={() => handleSelect(shape)}
                    />
                  );
                  break;
                case "ellipseFill":
                  return (
                    <Ellipse
                      key={shape.id}
                      id={shape.id}
                      x={shape.x}
                      y={shape.y}
                      stroke={shape.stroke}
                      fill={shape.fill}
                      strokeWidth={shape.strokeWidth}
                      scaleX={shape.scaleX}
                      scaleY={shape.scaleY}
                      radiusX={shape.radiusX}
                      radiusY={shape.radiusY}
                      customId={shape.id}
                      onMouseDown={() => handleSelect(shape)}
                      onTouchStart={() => handleSelect(shape)}
                    />
                  )
                  break;
                case "rectFill":
                  return (
                    <Rect
                      key={shape.id}
                      id={shape.id}
                      x={shape.x}
                      y={shape.y}
                      stroke={shape.stroke}
                      fill={shape.fill}
                      strokeWidth={shape.strokeWidth}
                      scaleX={shape.scaleX}
                      scaleY={shape.scaleY}
                      width={shape.width}
                      height={shape.height}
                      customId={shape.id}
                      onMouseDown={() => handleSelect(shape)}
                      onTouchStart={() => handleSelect(shape)}
                    />
                  );
                  break;
              
                default:
                  return null;
                  break;
              }
            })}
          </Layer>
        </Stage> */}
      </div>
    </React.Fragment>
  );
};

export default memo(DrawingTool);



const renderDrawComponent = (drawComponent: any, stageRef: any) => {
  const transferLineToComponentStage = (shape: any, stageRef: any) => {
    const line = stageRef.current.findOne(`#${shape.id}`);
    if (line) {
      let minX = 0;
      let minY = 0;
      shape.points.map((point: any, index: any) => {
        if (index % 2 === 0) {
          if (minX) {
            minX = Math.min(minX, point);
          } else {
            minX = point;
          }
        } else {
          if (minY) {
            minY = Math.min(minY, point);
          } else {
            minY = point;
          }
        }
      });
      minX = minX - (drawComponent.strokeWidth === 27? 32 : 16);
      minY = minY - (drawComponent.strokeWidth === 27? 32 : 16);
      const transformedPoints = shape.points.map((point: any, index: any) => {
        return index % 2 === 0 ? point - minX : point - minY;
      });
      return transformedPoints;
    } else {
      return [];
    }
  };
  
  if (drawComponent) {
    switch (drawComponent.type) {
      case "pencil":
        return (
          <Line
            key={drawComponent.id}
            id={drawComponent.id}
            x={0}
            y={0}
            points={transferLineToComponentStage(drawComponent, stageRef)}
            stroke={drawComponent.stroke}
            strokeWidth={drawComponent.strokeWidth}
            scaleX={drawComponent.scaleX}
            scaleY={drawComponent.scaleY}
            tension={0}
            lineCap="round"
            lineJoin="round"
            customId={drawComponent.id}
          />
        )
        break;
      case "highlighter":
        return (
          <Line
            key={drawComponent.id}
            id={drawComponent.id}
            x={0}
            y={0}
            points={transferLineToComponentStage(drawComponent, stageRef)}
            stroke={drawComponent.stroke}
            opacity={0.5}
            strokeWidth={drawComponent.strokeWidth}
            scaleX={drawComponent.scaleX}
            scaleY={drawComponent.scaleY}
            tension={0}
            lineCap="round"
            lineJoin="round"
            customId={drawComponent.id}
          />
        )
        break;
      case "line":
        return (
          <Line
            key={drawComponent.id}
            id={drawComponent.id}
            x={0}
            y={0}
            points={transferLineToComponentStage(drawComponent, stageRef)}
            stroke={drawComponent.stroke}
            strokeWidth={drawComponent.strokeWidth}
            scaleX={drawComponent.scaleX}
            scaleY={drawComponent.scaleY}
            tension={0.5}
            lineCap="round"
            lineJoin="round"
            customId={drawComponent.id}
          />
        )
        break;
      case "arrow":
        return (
          <Arrow
            key={drawComponent.id}
            id={drawComponent.id}
            x={0}
            y={0}
            points={transferLineToComponentStage(drawComponent, stageRef)}
            stroke={drawComponent.stroke}
            fill={drawComponent.fill}
            strokeWidth={drawComponent.strokeWidth}
            scaleX={drawComponent.scaleX}
            scaleY={drawComponent.scaleY}
            tension={0.5}
            lineCap="round"
            lineJoin="miter"
            customId={drawComponent.id}
          />
        )
        break;
      case "ellipse":
        return (
          <Ellipse
            key={drawComponent.id}
            id={drawComponent.id}
            x={(drawComponent.width / 2) + (drawComponent.strokeWidth === 27? 32 : 16)}
            y={(drawComponent.height / 2) + (drawComponent.strokeWidth === 27? 32 : 16)}
            stroke={drawComponent.stroke}
            fill={drawComponent.fill}
            strokeWidth={drawComponent.strokeWidth}
            scaleX={drawComponent.scaleX}
            scaleY={drawComponent.scaleY}
            radiusX={drawComponent.radiusX}
            radiusY={drawComponent.radiusY}
            customId={drawComponent.id}
          />
        )
        break;
      case "rect":
        return (
          <Rect
            key={drawComponent.id}
            id={drawComponent.id}
            x={(drawComponent.strokeWidth === 27? 32 : 16)}
            y={(drawComponent.strokeWidth === 27? 32 : 16)}
            stroke={drawComponent.stroke}
            fill={drawComponent.fill}
            strokeWidth={drawComponent.strokeWidth}
            scaleX={drawComponent.scaleX}
            scaleY={drawComponent.scaleY}
            width={drawComponent.width}
            height={drawComponent.height}
            customId={drawComponent.id}
          />
        );
        break;
      case "ellipseFill":
        return (
          <Ellipse
            key={drawComponent.id}
            id={drawComponent.id}
            x={(drawComponent.width / 2) + (drawComponent.strokeWidth === 27? 32 : 16)}
            y={(drawComponent.height / 2) + (drawComponent.strokeWidth === 27? 32 : 16)}
            stroke={drawComponent.stroke}
            fill={drawComponent.fill}
            strokeWidth={drawComponent.strokeWidth}
            scaleX={drawComponent.scaleX}
            scaleY={drawComponent.scaleY}
            radiusX={drawComponent.radiusX}
            radiusY={drawComponent.radiusY}
            customId={drawComponent.id}
          />
        )
        break;
      case "rectFill":
        return (
          <Rect
            key={drawComponent.id}
            id={drawComponent.id}
            x={(drawComponent.strokeWidth === 27? 32 : 16)}
            y={(drawComponent.strokeWidth === 27? 32 : 16)}
            stroke={drawComponent.stroke}
            fill={drawComponent.fill}
            strokeWidth={drawComponent.strokeWidth}
            scaleX={drawComponent.scaleX}
            scaleY={drawComponent.scaleY}
            width={drawComponent.width}
            height={drawComponent.height}
            customId={drawComponent.id}
          />
        );
        break;
    
      default:
        return null;
        break;
    }
  } else {
    return <></>;
  }
};